import {Container} from "react-bootstrap";
import TeamList from "../components/TeamsPage/TeamList";


const TeamsPage = () => {
    return (
        <Container>
            <TeamList/>
        </Container>
    );
};

export default TeamsPage;
